import React, { useEffect, useState } from 'react'
import { TextField, Button, Autocomplete, InputLabel, Select, MenuItem } from '@mui/material'
import AddIcon from '@mui/icons-material/Add';

// Some UI labels carry spaces the backend can't match on, so map those to the group key it
// expects. Anything not listed is sent through unchanged - the free-text search deliberately
// still sends "Search stims" with its space, which is what the backend matches on.
const GROUP_BY_SEARCH_PARAM = {
    'Ad Type Groups': 'AdTypeGroups',
    'Stim Id': 'StimId',
    'Search stims': 'SearchStims'
}

export function groupFor(searchParam) {
    return GROUP_BY_SEARCH_PARAM[searchParam] || searchParam
}

// The groups the backend casts to an int rather than trimming as a string.
const NUMERIC_GROUPS = ['AdTypeGroups', 'StimId']

export function isNumericGroup(group) {
    return NUMERIC_GROUPS.includes(group)
}

export default function SelectedSearchOption(props) {

    const { searchParam, fieldOptions, searchOptions, onApplyFilter, nameTerm, onNameChange } = props

    const [stimId, setStimId] = useState('')

    // clear the id box when the user switches to a different search option, so coming back
    // to it does not show a stale value that was never searched for
    useEffect(() => {
        setStimId('')
    }, [searchParam])

    // Hands the chosen filter up to StimSearchTableTop, which holds the applied set and
    // fires the search. `label` is only for display on the chip - `filter` is what is sent.
    function applyFilter(filter, label) {
        onApplyFilter({
            searchParam: searchOptions,
            group: groupFor(searchOptions),
            filter,
            label,
        })
    }

    function handleChange(event) {
        if (!event) {
            return
        }

        const value = event.target.value
        const chosen = fieldOptions.find((option) => option.value === value)

        applyFilter(value, chosen ? chosen.label : value)
    }

    // An id is an exact lookup, so it applies on Enter rather than per keystroke - typing
    // "2643" would otherwise fire four requests for ids 2, 26, 264 and 2643.
    function handleStimIdKeyDown(event) {
        if (event.key !== 'Enter') {
            return
        }

        const trimmed = stimId.trim()

        if (!trimmed) {
            return
        }

        applyFilter(Number(trimmed), trimmed)
    }

    return (
        <>
            {searchParam === 'Search stims' ? (
                <>
                    {/* controlled, so removing the name chip can clear it. The term is held by
                        StimSearchTableTop alongside the rest of the applied filters. */}
                    <TextField

                        variant="outlined"
                        label={props.textFieldLabel}
                        value={nameTerm || ''}
                        onChange={(e) => onNameChange(e.target.value)}
                        helperText="3 characters or more"
                    />

                </>
            ) : (
                null
            )
            }

            {searchParam === 'Stim Id' ? (
                <TextField
                    variant="outlined"
                    label="Stim Id"
                    value={stimId}
                    // digits only - the field is an id, so reject anything that cannot be one
                    onChange={(e) => setStimId(e.target.value.replace(/\D/g, ''))}
                    onKeyDown={handleStimIdKeyDown}
                    helperText="press Enter to add"
                    inputProps={{ inputMode: 'numeric' }}
                />
            ) : (
                null
            )
            }

            {searchParam === 'Brands' || searchParam === 'Languages' || searchParam === 'Countries' || searchParam === 'Ad Type Groups' ? (
                <>
                    <InputLabel id="demo-simple-select-label">{searchParam}</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={''}
                        label={`${searchParam}`}
                        onChange={handleChange}
                    >
                        {
                            fieldOptions.map((option, i) => {
                                return <MenuItem value={option.value} key={i}>{option.label}</MenuItem>
                            })
                        }
                    </Select>
                </>
            ) : (
                null
            )
            }
        </>
    )
}
